/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The provider of the auth support:
 *   * GIR
 *   * CLIPRO
 *   * SOGESMATIC
 */
export enum AuthSupportProvider {
  GIR = 'GIR',
  CLIPRO = 'CLIPRO',
  SOGESMATIC = 'SOGESMATIC'
}
